import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DatePicker, { registerLocale } from 'react-datepicker';
import it from 'date-fns/locale/it';
import { DatePickerContainer } from './style';
import 'react-datepicker/dist/react-datepicker.css';
import Icon from '../Icon';

registerLocale('it', it);

const CustomDatePicker = ({
  onChange,
  placeholder = 'Seleziona',
  value,
  name,
  valid = true,
  readonly,
  disabled,
  minDate,
  maxDate,
  widthInput = '100%',
  showTimeSelect = false,
  id,
}) => {
  const [val, setVal] = useState(value);

  useEffect(() => {
    setVal(value);
  }, [value]);

  const updateValue = (newValue) => {
    setVal(newValue);
    if (onChange) onChange(newValue);
  };

  return (
    <DatePickerContainer
      valid={readonly || valid}
      value={value}
      readonly={readonly}
      disabled={disabled}
      widthInput={widthInput}
    >
      <DatePicker
        locale="it"
        dateFormat="dd/MM/yyyy"
        onChange={updateValue}
        placeholderText={readonly ? '-' : placeholder}
        selected={val}
        name={name}
        readOnly={readonly}
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
        showTimeSelect={showTimeSelect}
        isClearable
        id={id}
      />
      <Icon type="calendar-date" />
    </DatePickerContainer>
  );
};

CustomDatePicker.propTypes = {
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  valid: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  widthInput: PropTypes.string,
  showTimeSelect: PropTypes.bool,
  id: PropTypes.string.isRequired,
};

export default CustomDatePicker;
